<template>
  <template-info :bgImg="bgImg" title="เราต้องจด VAT เมื่อไหร่">
    <div>เมื่อยอดขายหรือรายรับที่ได้มากกว่า</div>
    <div class="row-rectangle moblie">
      <div class="rectangle-blue">
        <h1>1.8</h1>
        <span>ล้านบาท/ ปี</span>
      </div>
      <div class="col-rectangle-gray">
        <div class="rectangle-gray">
          <span class="word-gray">หรือ</span>
          <div class="content-in-gray-rec">
            <h1>150,000</h1>
            <span>บาท/ เดือน</span>
          </div>
        </div>
        <div class="rectangle-gray">
          <span class="word-gray">หรือ</span>
          <div class="content-in-gray-rec">
            <h1>34,500</h1>
            <span>บาท/ สัปดาห์</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row-rectangle desktop">
      <div class="rectangle-blue">
        <div>
          <h1>1.8</h1>
          <span>ล้านบาท/ ปี</span>
        </div>
      </div>
      <div class="rectangle-gray">
        <div>
          <span class="word-gray">หรือ</span>
          <h1>150,000</h1>
          <span>บาท/ เดือน</span>
        </div>
      </div>
      <div class="rectangle-gray">
        <div>
          <span class="word-gray">หรือ</span>
          <h1>34,500</h1>
          <span>บาท/ สัปดาห์</span>
        </div>
      </div>
    </div>
    <div class="wrap-text">
      <span class="bold">เฉพาะรายได้ที่เราขายของได้</span>เท่านั้น <br />
      <span class="mark-alert">ไม่รวม</span> เงินเดือน โบนัส เบี้ยเลี้ยง OT
      ค่าเช่า
    </div>
    <chevron-right-link
      @clickLink="goVatCondition2"
      caption="การยื่นขอจด VAT"
      style="margin: 10px 0;"
    />
    <external-link
      @clickLink="goToExcerpVat"
      caption="กรณียกเว้นไม่ต้องจด VAT"
      class="link-desktop"
      style="margin-bottom: 20px;"
    />
    <div class="knowledge">
      <div class="col-img">
        <img src="@/assets/images/Vector.png" alt="knowledge" />
      </div>
      <div class="col-content-knowledge">
        แต่ยอดขายไม่ถึง 1.8 ล้านบาทต่อปี ก็จด VAT ล่วงหน้าได้นะ
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/vat_condition.png";

export default {
  name: "VatCondition",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goVatCondition2() {
      this.$router.push({ path: "/info/vat_condition_2" });
    },
  },
};
</script>

<style scoped>
.wivb-contents {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 23px;
  font-size: 17px;
  margin-bottom: 24px;
  color: #393d43;
}
.wivb-contents div {
  text-align: left;
}
.bold {
  font-weight: bold;
}
.row-rectangle {
  display: flex;
  margin: 16px 0;
}
.rectangle-blue {
  min-width: 126px;
  min-height: 195px;
  background: #99d6f1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.col-rectangle-gray {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.word-gray {
  color: #acb1bf;
  margin-left: 21px;
}
.rectangle-gray {
  min-width: 209px;
  min-height: 89px;
  background: #eff1f5;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.col-rectangle-gray .rectangle-gray:first-child {
  margin-bottom: 17px;
}
.content-in-gray-rec {
  text-align: center !important;
  margin-right: 21px;
}
.mark-alert {
  color: red;
  font-weight: bold;
}
.col-img {
  background: #99d6f1;
  width: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.col-content-knowledge {
  width: 299px;
  font-size: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 22px;
}
.col-content-knowledge div {
  width: 256px;
  text-align: left;
}
.wivbn-link {
  cursor: pointer;
  color: #6db6f6;
}
.knowledge {
  display: flex;
  max-width: 350px;
  border: 1px solid #99d6f1;
  height: 75px;
  border-radius: 5px;
  margin-top: 8px;
  margin-bottom: 50px;
}
.desktop {
  display: none;
}
.moblie {
  display: flex;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .moblie {
    display: none;
  }
  .desktop {
    display: flex;
  }
  .row-rectangle {
    width: 100%;
    min-height: 64px;
    height: 100%;
  }
  .rectangle-blue {
    flex: 1;
    min-height: 64px;
    flex-direction: row;
  }
  .rectangle-blue > div > h1 {
    margin-right: 5px;
    font-size: 34px;
  }
  .rectangle-blue > div {
    display: flex;
    align-items: baseline;
  }
  .rectangle-gray {
    min-height: 64px;
    flex: 1;
    justify-content: center;
  }
  .rectangle-gray > div > h1 {
    margin: 0 5px;
    font-size: 34px;
  }
  .rectangle-gray > div {
    display: flex;
    align-items: baseline;
  }
  .wrap-text br {
    display: none;
  }
  .knowledge {
    max-width: unset;
    height: 56px;
  }
  .col-content-knowledge {
    width: unset;
  }
}
</style>
